module.exports = __webpack_public_path__ + "static/media/player.f372822b.png";